import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import RadioButton from 'components/Form/RadioButton'
import Button from 'components/Button/index'
import { Dropdown, Radio } from 'antd'
import TextAreas from 'components/Form/TextArea'
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const ConfirmButton = styled(Button.Primary)`
  width: 123px;
  height: 38px;
  background: ${COLORS.PRIMARY};
  border-radius: 10px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
`
export const CancelButton = styled(Button.Secondary)`
  width: 88px;
  height: 38px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.PRIMARY};
  border: 1px solid #e3deff;
  background: #fbfaff;
`
export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
`
export const StyledRadio = styled(RadioButton)`
  margin-top: 10px;
`
export const AcceptOrRejectFlex = styled(Flex)``
export const RadioBtnSpan = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.GREY_P_100};
`
export const RadioBtnDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: ${COLORS.GREY_T_60};
`
export const StyledDropdown = styled(Dropdown)`
  cursor: pointer;

  padding-left: 10px;
`
export const RejectResonDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #4d566e;
  margin: 1rem 0.5rem;
`
export const StartSpan = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999fac;
`
export const RejectStyledRadio = styled(RadioButton)`
  border: none;
  padding: 5px 0;
`
export const AcceptTextArea = styled(TextAreas)`
  .ant-input {
    height: 72.5px;
  }
`
export const ErrorMessage = styled(StartSpan)`
  color: #fa0e0e;
`
